var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$store.state.hasLogin || (_vm.notUserInfoPageWatch && _vm.$route.path != '/login'))?_c('div',[_c('keep-alive',[_c('router-view')],1)],1):_vm._e(),(!_vm.notUserInfoPageWatch)?_c('div',[_c('valid-user')],1):_vm._e(),(!_vm.$store.state.hasLogin && _vm.$route.path == '/login')?_c('div',[_c('login')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }